import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './Patients.css';

const SimpleEditor = ({ value, onChange }) => {
    const editorRef = React.useRef(null);

    useEffect(() => {
        if (editorRef.current && value !== editorRef.current.innerHTML) {
            editorRef.current.innerHTML = value || '';
        }
    }, [value]);

    const handleCommand = (command) => {
        document.execCommand(command, false, null);
        if (editorRef.current) {
            onChange(editorRef.current.innerHTML);
            editorRef.current.focus();
        }
    };

    return (
        <div style={{ border: '2px solid #eaecf4', borderRadius: '10px', overflow: 'hidden', background: 'white' }}>
            <div style={{ background: '#f8f9fc', padding: '8px', borderBottom: '1px solid #eaecf4', display: 'flex', gap: '5px' }}>
                <button type="button" onClick={(e) => { e.preventDefault(); handleCommand('bold'); }} style={{ fontWeight: 'bold', padding: '5px 10px', cursor: 'pointer', border: '1px solid #ddd', background: 'white', borderRadius: '4px' }} title="Kalın">B</button>
                <button type="button" onClick={(e) => { e.preventDefault(); handleCommand('italic'); }} style={{ fontStyle: 'italic', padding: '5px 10px', cursor: 'pointer', border: '1px solid #ddd', background: 'white', borderRadius: '4px' }} title="İtalik">I</button>
                <button type="button" onClick={(e) => { e.preventDefault(); handleCommand('underline'); }} style={{ textDecoration: 'underline', padding: '5px 10px', cursor: 'pointer', border: '1px solid #ddd', background: 'white', borderRadius: '4px' }} title="Altı Çizili">U</button>
                <button type="button" onClick={(e) => { e.preventDefault(); handleCommand('insertUnorderedList'); }} style={{ padding: '5px 10px', cursor: 'pointer', border: '1px solid #ddd', background: 'white', borderRadius: '4px' }} title="Liste">• Liste</button>
            </div>
            <div ref={editorRef} contentEditable style={{ minHeight: '120px', padding: '10px', outline: 'none' }} onInput={(e) => onChange(e.currentTarget.innerHTML)} />
        </div>
    );
};

function Announcements() {
    const [announcements, setAnnouncements] = useState([]);
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [currentData, setCurrentData] = useState({ id: null, title: '', message: '', type: 'info', is_active: 1, clinic_id: '' });
    const [selectedAnnouncements, setSelectedAnnouncements] = useState([]);

    useEffect(() => {
        fetchAnnouncements();
        fetchClinics();
    }, []);

    const fetchClinics = () => {
        axios.get('./backend/get_clinics.php')
            .then(res => {
                setClinics(Array.isArray(res.data) ? res.data : []);
            })
            .catch(err => console.error(err));
    };

    const fetchAnnouncements = () => {
        axios.get('./backend/get_all_announcements.php')
            .then(res => {
                setAnnouncements(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const url = isEditing ? './backend/update_announcement.php' : './backend/save_announcement.php';
        
        axios.post(url, currentData)
            .then(res => {
                toast.success(res.data.message);
                setShowModal(false);
                fetchAnnouncements();
            })
            .catch(err => toast.error('İşlem başarısız.'));
    };

    const handleDelete = (id) => {
        if(window.confirm('Bu duyuruyu silmek istediğinize emin misiniz?')) {
            axios.post('./backend/delete_announcement.php', { id })
                .then(res => {
                    toast.success(res.data.message);
                    fetchAnnouncements();
                });
        }
    };

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus == 1 ? 0 : 1;
        axios.post('./backend/update_announcement.php', { id, is_active: newStatus })
            .then(res => {
                toast.success("Durum güncellendi.");
                fetchAnnouncements();
            });
    };

    const handleSelectAnnouncement = (id) => {
        if (selectedAnnouncements.includes(id)) {
            setSelectedAnnouncements(selectedAnnouncements.filter(item => item !== id));
        } else {
            setSelectedAnnouncements([...selectedAnnouncements, id]);
        }
    };

    const handleSelectAllAnnouncements = (e) => {
        if (e.target.checked) {
            setSelectedAnnouncements(announcements.map(a => a.id));
        } else {
            setSelectedAnnouncements([]);
        }
    };

    const handleBulkDeleteAnnouncements = () => {
        if (selectedAnnouncements.length === 0) return;
        if (window.confirm(`${selectedAnnouncements.length} adet duyuruyu silmek istediğinize emin misiniz?`)) {
            axios.post('./backend/delete_announcements_bulk.php', { ids: selectedAnnouncements })
                .then(res => {
                    toast.success(res.data.message);
                    fetchAnnouncements();
                    setSelectedAnnouncements([]);
                })
                .catch(err => toast.error("Silme işlemi başarısız."));
        }
    };

    const openModal = (data = null) => {
        if (data) {
            setCurrentData({ ...data, clinic_id: data.clinic_id || '' });
            setIsEditing(true);
        } else {
            setCurrentData({ id: null, title: '', message: '', type: 'info', is_active: 1, clinic_id: '' });
            setIsEditing(false);
        }
        setShowModal(true);
    };

    if (loading) return <div>Yükleniyor...</div>;

    return (
        <div className="patients-container">
            <div className="header-actions">
                <h2>Duyuru Yönetimi</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    {selectedAnnouncements.length > 0 && (
                        <button onClick={handleBulkDeleteAnnouncements} className="delete-btn" style={{ fontSize: '0.9rem', padding: '8px 15px' }}>
                            Seçilenleri Sil ({selectedAnnouncements.length})
                        </button>
                    )}
                    <button className="add-btn" onClick={() => openModal()}>+ Yeni Duyuru</button>
                </div>
            </div>

            <table className="data-table">
                <thead>
                    <tr>
                        <th style={{width: '40px'}}><input type="checkbox" onChange={handleSelectAllAnnouncements} checked={announcements.length > 0 && selectedAnnouncements.length === announcements.length} /></th>
                        <th>ID</th>
                        <th>Başlık</th>
                        <th>Mesaj</th>
                        <th>Hedef</th>
                        <th>Tür</th>
                        <th>Durum</th>
                        <th>Tarih</th>
                        <th style={{textAlign: 'right'}}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {announcements.map(ann => (
                        <tr key={ann.id}>
                            <td><input type="checkbox" checked={selectedAnnouncements.includes(ann.id)} onChange={() => handleSelectAnnouncement(ann.id)} /></td>
                            <td>{ann.id}</td>
                            <td>{ann.title}</td>
                            <td>{ann.message.replace(/<[^>]+>/g, '').substring(0, 50)}{ann.message.replace(/<[^>]+>/g, '').length > 50 ? '...' : ''}</td>
                            <td>
                                {ann.clinic_name ? (
                                    <span style={{background: '#e3f2fd', color: '#4e73df', padding: '3px 8px', borderRadius: '12px', fontSize: '0.8rem'}}>
                                        {ann.clinic_name}
                                    </span>
                                ) : (
                                    <span style={{background: '#f8f9fc', color: '#858796', padding: '3px 8px', borderRadius: '12px', fontSize: '0.8rem'}}>
                                        Genel
                                    </span>
                                )}
                            </td>
                            <td>
                                <span className={`status-badge`} style={{
                                    backgroundColor: ann.type === 'danger' ? '#ffebee' : (ann.type === 'warning' ? '#fff3cd' : '#e3f2fd'),
                                    color: ann.type === 'danger' ? '#c62828' : (ann.type === 'warning' ? '#856404' : '#0d47a1')
                                }}>
                                    {ann.type.toUpperCase()}
                                </span>
                            </td>
                            <td>
                                <button 
                                    className={`status-badge ${ann.is_active == 1 ? 'status-completed' : 'status-cancelled'}`}
                                    onClick={() => handleToggleStatus(ann.id, ann.is_active)}
                                    style={{border: 'none', cursor: 'pointer'}}
                                >
                                    {ann.is_active == 1 ? 'Aktif' : 'Pasif'}
                                </button>
                            </td>
                            <td>{new Date(ann.created_at).toLocaleDateString()}</td>
                            <td style={{textAlign: 'right'}}>
                                <div className="action-buttons" style={{justifyContent: 'flex-end'}}>
                                    <button className="edit-btn" onClick={() => openModal(ann)}>Düzenle</button>
                                    <button className="delete-btn" onClick={() => handleDelete(ann.id)}>Sil</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{isEditing ? 'Duyuru Düzenle' : 'Yeni Duyuru'}</h3>
                            <button className="close-modal-btn" onClick={() => setShowModal(false)}>✕</button>
                        </div>
                        <div className="modal-body">
                            <form id="annForm" onSubmit={handleSubmit}>
                                <div className="form-group"><label>Başlık</label><input type="text" value={currentData.title} onChange={e => setCurrentData({...currentData, title: e.target.value})} required /></div>
                                <div className="form-group">
                                    <label>Mesaj</label>
                                    <SimpleEditor value={currentData.message} onChange={(val) => setCurrentData({...currentData, message: val})} />
                                </div>
                                <div className="form-group"><label>Tür</label><select value={currentData.type} onChange={e => setCurrentData({...currentData, type: e.target.value})} style={{width:'100%', padding:'10px', border:'2px solid #eaecf4', borderRadius:'10px'}}><option value="info">Bilgi</option><option value="warning">Uyarı</option><option value="danger">Kritik</option><option value="success">Başarılı</option></select></div>
                                <div className="form-group">
                                    <label>Hedef Klinik (Opsiyonel)</label>
                                    <select value={currentData.clinic_id} onChange={e => setCurrentData({...currentData, clinic_id: e.target.value})} style={{width:'100%', padding:'10px', border:'2px solid #eaecf4', borderRadius:'10px'}}>
                                        <option value="">Tüm Klinikler (Genel Duyuru)</option>
                                        {clinics.map(c => (
                                            <option key={c.id} value={c.id}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </form>
                        </div>
                        <div className="modal-actions">
                            <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>İptal</button>
                            <button type="submit" form="annForm" className="save-btn">Kaydet</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Announcements;